export default (purchaseLimitation) => {
  if (purchaseLimitation) {
    return `limitation_${purchaseLimitation}`
  } else {
    return ''
  }
}
